import React, { useState } from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import { FaFigma } from "react-icons/fa";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { HashLink  } from "react-router-hash-link";
import { Link } from "react-router-dom";


import logo from "../img/Rushk.png";
import logo2 from "../img/Rushk.gif";

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const handleNav = () => {
    setNav(!nav);
  };
  return (
    <div className="flex justify-between items-center h-20 max-w-[1240px] mx-auto mt-5 px-3 ptext-black">
     <Link to="/"> <img src={logo2} className="object-contain h-18 w-20 pt-2" alt="logo" /></Link>

      <ul className=" hidden md:flex">
        <li className="p-4 text-[#000000] font-bold 	"><HashLink to="#homeintro" smooth>Intro</HashLink></li>
        <li className="p-4  text-[#000000] font-bold "><HashLink to="#homeabout" smooth>About_me</HashLink></li>
        <li className="p-4 text-[#000000] font-bold "><HashLink to="#homeprojects" smooth>Project</HashLink></li>
        <li className="p-4 text-[#000000] font-bold "><HashLink to="#homeskills" smooth>Skills</HashLink></li>
        <li className="p-4 text-[#000000] font-bold "><HashLink to="#homecontact" smooth>Contact</HashLink></li>
       {/* <li className="py-4 pl-10">
          <Link to="https://github.com/45aman"><GitHubIcon /></Link>
        </li>
        <li className="py-4">
          <Link to="https://www.linkedin.com/in/aman-shaikh-671b60226/"><LinkedInIcon /></Link>
        </li>
        <li className="py-4">
          <Link to="https://www.instagram.com/_amu_456_/"><InstagramIcon /></Link>
        </li>
        <li className="py-5 pr-4 ">
          <Link to="https://www.figma.com/files/recents-and-sharing/recently-viewed?fuid=1087804051819283768"><FaFigma size="1.3rem" /></Link>
        </li>*/}
        <Link to="https://drive.google.com/file/d/1C6ed7Om5WUr6s5Jvb_8UMDVlw2Adc7Jz/view?usp=drive_link">
        <button className="text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2 my-2"
            >
          Download CV
        </button>
        </Link>
      </ul>
      <div onClick={handleNav} className="block md:hidden">
        {!nav ? <AiOutlineClose size={20} /> : <AiOutlineMenu size={20} />}
      </div>
      <div
        className={
          !nav
            ? "fixed right-10 top-20  border-r border-r-grey-800 block md:hidden bg-white pl-5"
            : "fixed left-[-100%]"
        }
      >
        <ul className="uppercase">
        
        <li className="p-4 text-[#000000] font-bold 	"><HashLink to="#homeintro" smooth>Intro</HashLink></li>
        <li className="p-4  text-[#000000] font-bold "><HashLink to="#homeabout" smooth>About_me</HashLink></li>
        <li className="p-4 text-[#000000] font-bold "><HashLink to="#homeprojects" smooth>Project</HashLink></li>
        <li className="p-4 text-[#000000] font-bold "><HashLink to="#homeskills" smooth>Skills</HashLink></li>
        <li className="p-4 text-[#000000] font-bold "><HashLink to="#homecontact" smooth>Contact</HashLink></li>
         {/*} <li className="p-6">
            <GitHubIcon />
          </li>
          <li className="p-6">
            <LinkedInIcon />
          </li>
          <li className="p-6">
            <InstagramIcon />
          </li>
          <li className="p-6 pr-4 ">
            <FaFigma size="1.3rem" />
          </li>*/}
        </ul>
        <Link to="https://drive.google.com/file/d/1C6ed7Om5WUr6s5Jvb_8UMDVlw2Adc7Jz/view?usp=drive_link">
        <button className="text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
            >
          Download CV
        </button>
        </Link>
      </div>
    </div>
  );
};
export default Navbar;
